<template>
    <app-layout class="practice-ancillary-tests">
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
            </common-content-spacer>

            <common-page-plain>
                <common-content-spacer height="medium">
                    <div class="practice-ancillary-tests--header">
                        <common-icon name="ancillary-diagnostic" size="gigantic"></common-icon>
                        <p class="practice-ancillary-tests--header--text">{{ pageSubTitle }}</p>
                    </div>
                    <common-content-spacer v-if="ancillaryService.length" height="medium" class="practice-ancillary-tests-items">
                        <div v-for="(item, index) in ancillaryService" :key="index">
                            <div class="practice-ancillary-tests--item">
                                <span class="practice-ancillary-tests--item--name">{{ item.locationName }}</span>
                                <common-button
                                    :isSubmittable="false"
                                    :label="
                                        item.facilityServiceTypesSubgroups.length
                                            ? $t('forms.practice_ancillary.button.modify')
                                            : $t('forms.practice_ancillary.button.add_tests')
                                    "
                                    type="primary"
                                    size="small-font"
                                    @click="openModifyTestsPage(item.practiceLocationId)"
                                ></common-button>
                            </div>
                            <common-badges-list
                                class="practice-ancillary-tests--list"
                                :listElements="item.facilityServiceTypesSubgroups.map((n) => n.name)"
                            ></common-badges-list>
                            <div></div>
                        </div>
                    </common-content-spacer>
                    <div class="practice-ancillary-tests__done">
                        <common-button
                            :isSubmittable="false"
                            :disabled="isSaveDisabled"
                            :label="$t('common.microcopy.save')"
                            type="primary"
                            size="small-font"
                            @click="goToNextService()"
                        ></common-button>
                    </div>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin],

        components: {
            AppLayout,
        },

        data() {
            return {
                ancillaryService: [],
                isLoading: false,
                facilityServices: [],
                header: '',
                facilityServicesIndex: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.practice.profile.titles.practice_profile', { practiceName: this.$auth.getPractice().name })
            },

            pageSubTitle() {
                return this.$auth
                    .getFacilityServicesByLocation()
                    .find((el) => Number(el.facilityServiceTypeId) === Number(this.$route.params.serviceId))
                    .facilityServiceTypeName
            },

            isSaveDisabled() {
                return this.ancillaryService.some((item) => {
                    return item.facilityServiceTypesSubgroups.length === 0
                })
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.practice'),
                        route: { name: 'practice.members' },
                    },
                    {
                        label: this.$t('pages.practice.profile.breadcrumbs.practice_profile'),
                        route: { name: 'practice.profile-ancillary' },
                    },
                    {
                        label: this.$t('pages.practice.profile.breadcrumbs.practice_tests_list'),
                    },
                ]
            },

            showSelectMoreTestsButton() {
                return this.facilityServices.length && this.facilityServicesIndex + 1 < this.facilityServices.length
            },
        },

        methods: {
            loadData() {
                FacilityServicesAPI.getServiceTests(this.$auth.getPractice().id, this.$route.params.serviceId).then(
                    (response) => {
                        this.ancillaryService = response
                    },
                )
            },

            openModifyTestsPage(id) {
                this.$router.push({
                    name: 'practice.service.tests.modify',
                    params: { serviceId: this.$route.params.serviceId, locationId: id.toString() },
                    query: { advance: this.$route.query.advance ? this.$route.query.advance : false },
                })
            },

            goToNextService() {
                const isAdvance = !!this.$route.query.advance
                const el = this.facilityServices.find(
                    (item, index) =>
                        item.facilityServiceTypesGroups.some((group) => group.facilityServiceTypesSubgroups.length === 0) &&
                        index > this.facilityServicesIndex,
                )

                if (!isAdvance || !el?.id) {
                    this.$router.push({ name: 'practice.profile-ancillary' })
                    return
                }

                this.$router.push(`/practice/service/${el.id}/tests?advance=true`)
                this.ancillaryService = []
                this.loadData()
            },

            setDataForNextService() {
                this.facilityServices = this.$auth.getPractice().facilityServiceTypes
                this.facilityServicesIndex = this.facilityServices.findIndex(
                    (obj) => Number(obj.id) === Number(this.$route.params.serviceId),
                )
            },
        },

        mounted() {
            this.loadData()
            this.setDataForNextService()
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .practice-ancillary-tests {
        &--header {
            display: flex;
            align-items: center;
            &--text {
                font-weight: 500;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: 0.325px;
                color: $color-black;
            }
            .icon {
                margin-right: 22px;
            }
        }
        &__back-button {
            .icon {
                margin-top: 10px;
            }
        }

        &-items {
            margin-left: 90px;
        }

        &--list {
            box-shadow: 0px 1px 0px $color--border-switch;
            width: 70%;
            padding-bottom: 15px;
        }

        &--item {
            display: flex;
            padding: 10px;
            justify-content: space-between;
            align-items: center;

            &--name {
                font-weight: 500;
                font-size: 14px;
                line-height: 21px;
                letter-spacing: 0.178095px;
                color: $color--txt-base-6;
            }
        }

        &__done {
            text-align: center;

            .button {
                margin-right: 10px;
            }
        }
    }
</style>
